import { useHistory } from 'react-router-dom'
import { postRequest } from 'utils/http'
import analytics from 'utils/analytics'
import { useUser } from './useUser'

const useLogout = () => {
  const { userProxy } = useUser()
  const { push } = useHistory()

  async function logout() {
    try {
      await postRequest('users/logout')
    } catch (_) {
      // Server-side clear is best-effort; always clear client state below.
    }
    analytics.reset()
    userProxy.set(null)
    return push('/')
  }

  return [logout]
}

export { useLogout }
